import React, { useState, useEffect } from 'react';
import './VisitLOS.css';

const VisitLOS = ({ value = 0, min = 0, max = 90, isRunning = false, onRefresh, isAutoDischarged = false }) => {
  const [currentValue, setCurrentValue] = useState(value);

  // Update value when prop changes (from backend)
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  // If visit is running, refresh the value periodically from backend
  useEffect(() => {
    if (!isRunning || !onRefresh) {
      return;
    }

    // Refresh every 60 seconds to get updated LOS from backend
    const interval = setInterval(() => {
      onRefresh();
    }, 60000);

    return () => clearInterval(interval);
  }, [isRunning, onRefresh]);

  // Calculate the position percentage for the marker (cap at 100% visually but allow values beyond max)
  const positionPercentage = Math.min(100, ((currentValue - min) / (max - min)) * 100);
  // Check if time exceeds maximum
  const isExceeded = currentValue > max;
  // Check if visit is discharged (not running)
  const isDischarged = !isRunning;

  return (
    <div className="visit-los">
      {/* Visit LOS Label */}
      <span className="visit-los__label">
        {isAutoDischarged && <span style={{ marginRight: '4px', color: '#dc3545' }}>*</span>}
        Visit LOS
      </span>

      {/* Gradient Bar Container */}
      <div className="visit-los__bar-wrapper">
        {/* Gradient Bar */}
        <div className="visit-los__bar">
          {/* Left Label */}
          <span className="visit-los__edge-label">
            {min}m
          </span>

          {/* Right Label */}
          <span className="visit-los__edge-label">
            {max}m
          </span>
        </div>

        {/* Marker with dashed line */}
        <div
          className="visit-los__marker"
          style={{ left: `${positionPercentage}%` }}
        >
          {/* Marker Box */}
          <div className={`visit-los__marker-value ${isExceeded ? (isDischarged ? 'visit-los__marker-value--exceeded-discharged' : 'visit-los__marker-value--exceeded') : ''}`}>
            {currentValue}m
            {/* Teardrop/Triangle pointing down */}
            <div className={`visit-los__marker-pointer ${isExceeded ? 'visit-los__marker-pointer--exceeded' : ''}`}></div>
          </div>

          {/* Dashed Line connecting marker to bar */}
          <div className="visit-los__marker-line"></div>
        </div>
      </div>
    </div>
  );
};

export default VisitLOS;

